/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useRef } from "react";
import {
  onLoginAuthReset,
  onLoginAuthSubmit,
} from "../../Store/Slices/loginAuthSlice";
import {
  onTranslationReset,
  onTranslationSubmit,
} from "../../Store/Slices/translationSlice";
import { useDispatch, useSelector } from "react-redux";
import RouteConfiq from "../../Routing/routes";
import Loader from "../../Components/Loader/Loader";
import PageError500 from "../../Components/PageError/PageError";
import axiosInstance from "../../Common/Axios/axiosInstance";
import axiosInstanceClient from "../../Common/Axios/axiosInstanceClient";
import API from "../../Common/Endpoint/serviceConstrants";
import { onGetThemeData } from "../../Store/Slices/themeSlice";
import {
  clientData,
  resetClientData,
} from "../../Store/Slices/clientDataSlice";
import { GetImageUrl, trackEvent } from "../../Components/Utility/Utility";
import getTranslationData from "../../TranslationUtility/TranslationUtility";
import { onSaveCredsGet } from "../../Store/Slices/cardDataSlice";
import { useNavigate } from "react-router-dom";
import PasswordProtectedModal from "./PasswordProtectedModal";
import { passwordModalChecked } from "../../Store/Slices/clientConfigDataSlice";
import { encryptAES } from "../../Common/Axios/encrypt";
const Auth = () => {
  const dispatch = useDispatch();
  const translation = getTranslationData();
  const [showLoader, setShowLoader] = useState(true);
  const [showError, setShowError] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [pageError, setPageError] = useState({
    StatusCode: "",
    ErrorName: "",
    ErrorDesription: "",
    url: "",
    buttonText: "",
  });
  const loginAuthData = useSelector((state) => state.loginAuthReducer);
  const translationData = useSelector((state) => state.translationReducer);
  const clientinfo = useSelector((state) => state.clientDataReducer);
  useEffect(() => {
    let isMounted = true;

    const fetchClientInfo = async () => {
      try {
        const data = await getClientInfo();
        if (isMounted) {
          if (!data) {
            setShowError(true);
            dispatch(resetClientData());
            setPageError({
              StatusCode: "401",
              ErrorName: translation?.errorName,
              ErrorDesription: translation?.applicationUrlIsNotRegistered,
              url: "/",
              buttonText: translation?.backToHome,
            });
          } else {
            if (data?.response?.clientCode) {
              axiosInstance.defaults.headers["client-code"] =
                data.response.clientCode;
              dispatch(clientData(data.response));
            }
            setShowError(false);
          }
        }
      } catch (error) {
        if (isMounted) {
          console.error("Error fetching client info:", error);
          setShowError(true);
          setPageError({
            StatusCode: "401",
            ErrorName: translation?.errorName,
            ErrorDesription: translation?.applicationUrlIsNotRegistered,
            url: "/",
            buttonText: translation?.backToHome,
          });
        }
      }
    };

    fetchClientInfo();
    return () => {
      isMounted = false; // Cleanup flag when component unmounts
    };
  }, []);
  const navigate = useNavigate();

  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === "logout") {
        sessionStorage.removeItem("login");
        localStorage.setItem("contactUs_reloaded", 'false');
      }
    };

    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, [navigate]);
  useEffect(() => {
    if (clientinfo.clientCode && sessionStorage.getItem("ivkey")) {
      axiosInstance.defaults.headers["client-code"] = clientinfo.clientCode;
      axiosInstanceClient.defaults.headers["client-code"] =
        clientinfo.clientCode;
      axiosInstance.defaults.headers["Encryption"] = 2;
      axiosInstanceClient.defaults.headers["Encryption"] = 2;
      setShowLoader(true);
      dispatch(onTranslationReset());
      dispatch(
        onLoginAuthSubmit({
          partnerCode: clientinfo.userType,
          accessKey: process.env.REACT_APP_ENV_KEY,
          secretKey: process.env.REACT_APP_PRIVATE_KEY,
        })
      );
      axiosInstance.defaults.headers["partner-code"] = clientinfo.userType;
      axiosInstanceClient.defaults.headers["partner-code"] =
        clientinfo.userType;
    }
  }, [clientinfo.clientCode, sessionStorage.getItem("ivkey")]);

  const getClientInfo = async () => {
    try {
      setShowLoader(true);
      const { data = {} } = await axiosInstance.get(API.clientbyid, {
        params: {
          platformDomainUrl: window.location.origin,
        },
        headers: {
          ...axiosInstance.defaults.headers,
          Userid: process.env.REACT_APP_USER_Name,
          Password: process.env.REACT_APP_USER_PASSWORD,
          Encryption: 1,
        },
      });
      return data;
    } catch (ex) {
      return null;
    } finally {
      setShowLoader(false);
    }
  };

  useEffect(() => {
    if (loginAuthData?.status_code === 200) {
      document.title = clientinfo.title;
      const link = document.querySelector("link[rel='icon']");
      if (link) {
        link.href = GetImageUrl(clientinfo?.favIconImage);
      }
      sessionStorage.setItem("clientCode", loginAuthData?.data?.[0]?.clientId);
      sessionStorage.setItem("expirytime", new Date(loginAuthData?.data?.[0]?.expiryTime));
      sessionStorage.setItem("expiryTimeInMintue", loginAuthData?.data?.[0]?.expiryTimeInMintue);
      sessionStorage.setItem("authToken", encryptAES(loginAuthData?.data?.[0]?.token));
      dispatch(onGetThemeData({ id: parseInt(clientinfo.themeId) }));
      dispatch(onTranslationSubmit());
      dispatch(onSaveCredsGet("V3IntegrationFront"));
      dispatch(onLoginAuthReset());
    } else if (loginAuthData?.status_code) {
      setShowError(true);
      setShowLoader(false);
      setPageError({
        StatusCode: loginAuthData?.status_code,
        ErrorName: translation?.internalServerError,
        ErrorDesription: translation?.permissionToViewThisResource,
        url: "/",
        buttonText: translation?.backToHome,
      });
    }
  }, [loginAuthData]);

  useEffect(() => {
    if (translationData.status_code === 200 && !translationData?.isLoading) {
      setShowLoader(false);
      setShowError(false);
      setIsAuthenticated(true);
      dispatch(onTranslationReset());
    } else if (
      translationData?.status_code !== 200 &&
      translationData?.status_code
    ) {
      setShowError(true);
      setShowLoader(false);
      setPageError({
        StatusCode: "500",
        ErrorName: translation?.internalServerError,
        ErrorDesription: translation?.permissionToViewThisResource,
        url: "/",
        buttonText: translation?.backToHome,
      });
    }
  }, [translationData]);
  //import { useEffect, useRef } from "react";
  const trackedMilestonesRef = useRef(new Set()); // ✅ declare here, not inside useEffect
  const clientConfigurations = clientinfo?.clientData?.clientConfigurations;

  // get the config object once, parse its value reliably and avoid name collisions
  const _passwordProtectedConfig = clientConfigurations?.find(
    (item) => item?.configKey?.toLowerCase() === "ispasswordprotected"
  );
  const isPasswordProtected = Boolean(
    _passwordProtectedConfig &&
    (_passwordProtectedConfig.configValue === true ||
      _passwordProtectedConfig.configValue === "true" ||
      _passwordProtectedConfig.configValue === 1 ||
      _passwordProtectedConfig.configValue === "1")
  );
  const isProtectedDescription = _passwordProtectedConfig?.description || "";

  const [showModal, setShowModal] = useState(false);
  const handleClose = () => setShowModal(false);
  // avoid shadowing the imported action name; use a clear selector name
  const passwordChecked = useSelector(
    (state) => state.clientConfigDataReducer?.passwordChecked
  );
  useEffect(() => {

    const handleScroll = () => {


      const scrollTop = window.scrollY;
      const windowHeight = window.innerHeight;
      const docHeight = document.documentElement.scrollHeight;

      const scrollPercent = Math.round(((scrollTop + windowHeight) / docHeight) * 100);

      const milestones = [25, 50, 75, 100];

      milestones.forEach((milestone) => {
        if (scrollPercent >= milestone && !trackedMilestonesRef.current.has(milestone)) {
          trackedMilestonesRef.current.add(milestone);

          trackEvent("scroll_depth", {
            ecommerce: {
              page_name: window.location.pathname,
              page_url: window.location.href,
              scroll_percent: milestone,
            },
          });

        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    // open modal only when config enables protection and user hasn't checked the modal
    if (isPasswordProtected && !passwordChecked) {
      setShowModal(true);
    } else {
      setShowModal(false);
    }
  }, [isPasswordProtected, passwordChecked]);

  return (
    <>
      {showModal ?
        // <Loader />
        (
          <PasswordProtectedModal
            show={showModal}
            // modalClass={""}
            isprotectedDescription={isProtectedDescription}
            handleClose={handleClose}
          />

        ) : (
          <>
            {showError ? (
              <PageError500 pageError={pageError} />
            ) : (
              isAuthenticated && <RouteConfiq />
            )}
          </>
        )}
    </>
  );
};

export default Auth;
